import { FaFileUpload } from "react-icons/fa";
import TableFile from "./TableFile";


const Files = ({error, files, setFiles, setError}) => {

    const changeHandler = (e) => {
        let selected = e.target.files[0];
        //console.log(selected);
        if (selected && selected.type === 'application/pdf') {
            if(selected.size > 5000000) {
                setError('File size is too large.');
            } else {
                //setFiles([...files, selected]);
                setFiles(selected);
                setError(null);
                //console.log('is small');
            }
           // console.log(selected);
        } else {
            setError('Please select a valid PDF file.');

        }

    }

    return ( 
        <>
            <h5 className="title is-size-5-touch has-text-weight-bold mt-6 mb-2 grey-text text-darken-3">Upload Document</h5>
            <div className="divider mb-5"></div>

            <p className="block grey-text text-darken-1">
                Please provide the document to support your application.<br/>
                <b>Note:</b> Document should only be in PDF format <b>only</b>
            </p>
            <div className="row">
                <div className="col s10 m6 offset-s1 ">
                    <div className="file-field input-field">
                        <div
                            className="button is-success mt-3"
                        >
                            <span className="icon">
                                <FaFileUpload />
                            </span>
                            <span>Select File</span>
                            <input type="file"  onChange={changeHandler} accept="application/pdf" />
                        </div>
                        <div className="file-path-wrapper">
                            <input className="file-path" type="text" placeholder="Select a PDF file" />
                        </div>
                    </div>
                </div>
            </div>
            {
                error && <p className="red-text text-darken-3">{error}</p>
            }
            {
                files !== null && <TableFile files={files} setFiles={setFiles}/>
            }
            <div className="mt-4 mb-4">
                <p className="grey-text text-darken-2"><span className="has-text-weight-bold">NB: </span>Please select a pdf which contain all your documents.</p>
            </div>
            
        </>
     );
}
 
export default Files;